var _metadata, _defs, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppdynamics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64.000005 63.999999",
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata23"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs21"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\n\t.st0{fill:#232736;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "g45",
    transform: "matrix(5.3440923,0,0,5.3440923,-72.14965,-118.02575)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 18.971019,32.853173 -3.50302,-7.299396 c -0.845556,0.776532 -1.3805,1.880932 -1.3805,3.123382 0,2.329595 1.898188,4.227783 4.227782,4.227783 0.224332,0 0.431407,-0.01726 0.655738,-0.05177",
    id: "path12",
    style: {
      fill: "#272627",
      strokeWidth: 0.17256255,
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 17.53875,24.518402 c 0.258844,-0.05177 0.517688,-0.06902 0.776531,-0.06902 2.329595,0 4.227783,1.898188 4.227783,4.227782 0,1.276963 -0.569456,2.433132 -1.484038,3.209664 l 1.035375,2.174288 c 1.691113,-1.190682 2.795514,-3.157895 2.795514,-5.383952 0.01726,-3.64107 -2.933564,-6.591889 -6.574634,-6.591889 -0.621225,0 -1.24245,0.08628 -1.811906,0.258844 z",
    id: "path14",
    style: {
      fill: "#272627",
      strokeWidth: 0.17256255,
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppdynamics);
export default __webpack_public_path__ + "static/media/appdynamics.9ac25a3bf94194d9a738ee0c17ccb360.svg";
export { ForwardRef as ReactComponent };